import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { TypeResponsibleOutputDTO } from './typeResponsibleDTO'
import { IsAuthorized } from 'src/authentication/IsAuthorized'
class TypeResponsibleService {
  async getByAll(): Promise<TypeResponsibleOutputDTO[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/type-responsible/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}
export const typeResponsibleService = new TypeResponsibleService()
